
import { Rule, RuleGroup } from "csi/middleware/attributeRule/RuleStore";
import { C8DateRange } from "designSystem/components/dateRange/DateRange";
import MultiSelect from "designSystem/components/select/MultiSelect";
import { DateRangeTimePicker, NumberTextField, SingleSelect, TextField } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Operator } from "src/c8-platform/type/operators";

interface CustomViewFilterValueSelectionProps {
	/** the index of this filter */
	index: number;

	/** the filter that stores this value selection */
	filter: Rule;

	/** Filter Group that stores this filter; will be null if filter is not in a filter group */
	filterGroup?: RuleGroup;
}

const CustomViewFilterValueSelection: FunctionComponent<CustomViewFilterValueSelectionProps> = observer((props) => {
	const {
		filter,
	} = props;

	const {
		createValueStore,
		numberTextFieldValue,
		onBlurValueNumberField,
		onChangeValueDateRange,
		onChangeValueMultiSelect,
		onChangeValueSingleSelect,
		onChangeValueNumberField,
		onChangeValueTextField,
		selectedOperator: { id: selectedOperatorId },
		selectedValues,
		selectedValueForTextField,
		setIsDateValid,
		showDatePicker,
		showDatePickerTime,
		showDateRangePicker,
		showMultiSelect,
		showNumberField,
		showSingleSelect,
		showTextField,
		valueList,
		visibilityOfSelect,
	} = filter || {};

	return (
		<>
			{showSingleSelect && (
				<SingleSelect
					allowCustomOptions={false}
					fullWidth
					grouped
					onChange={onChangeValueSingleSelect}
					onOpenCallback={createValueStore}
					options={valueList}
					placeHolderRes="Value"
					value={selectedValues[0]}
				/>
			)}
			{showMultiSelect && (
				<MultiSelect
					allowCustomOptions={false}
					fullWidth
					limitTags={4}
					onChange={onChangeValueMultiSelect}
					onOpenCallback={createValueStore}
					options={valueList}
					placeHolderRes="AttributeValues"
					sx={visibilityOfSelect}
					value={selectedValues}
				/>
			)}
			{showTextField && (
				<TextField
					fullWidth
					onChange={onChangeValueTextField}
					sx={visibilityOfSelect}
					value={selectedValueForTextField}
				/>
			)}
			{showNumberField && (
				<NumberTextField
					inputProps={{
						onBlur: onBlurValueNumberField,
						onChange: onChangeValueNumberField,
					}}
					value={numberTextFieldValue}
				/>
			)}
			{showDatePicker && (
				<DateRangeTimePicker
					initialRange={
						new C8DateRange(
							...(selectedValues.map(
								({ value }) => (value))),
						)
					}
					mode={showDateRangePicker ? "range" : "single"}
					onRangeChange={onChangeValueDateRange}
					onViolationChange={setIsDateValid}
					selectedOperatorId={selectedOperatorId as Operator}
					showTime={showDatePickerTime}
				/>
			)}
		</>
	);
});

export default CustomViewFilterValueSelection;